export default __webpack_public_path__ + "static/media/about_odoo.6467367e.jpg";